import { useState } from 'react';
import { useQuery } from '@tanstack/react-query';
import { PermanentJobsService } from '../services';

const ROWS_PER_PAGE = 15;

export const useGetCandidates = (postingId, options) => {
  const [filters, setFilters] = useState({
    name: '',
    status: '',
    page: 1,
  });

  const {
    data: response,
    isLoading,
    isError,
    error,
    refetch,
  } = useQuery({
    queryKey: ['GET_CANDIDATES', postingId, filters],
    queryFn: async () =>
      PermanentJobsService.getCandidates({
        postingId,
        page: filters.page,
        pageSize: ROWS_PER_PAGE,
        status: filters.status,
        name: filters.name,
      }),
    retry: false,
    enabled: !!postingId,
    refetchOnWindowFocus: options?.refetchOnWindowFocus ?? false,
  });

  const handleFilterChange = (key, value) => {
    setFilters((prev) => {
      if (prev[key] === value) {
        return prev;
      }
      return {
        ...prev,
        [key]: value,
        page: 1,
      };
    });
  };

  const handlePageChange = (page) => {
    setFilters((prev) => ({
      ...prev,
      page,
    }));
  };

  return {
    data: response?.data || [],
    filters,
    isLoading,
    total: response?.total || 0,
    totalPages: Math.ceil((response?.total || 0) / ROWS_PER_PAGE),
    isError,
    error,
    refetch,
    handleFilterChange,
    handlePageChange,
  };
};
